import AccordionMenu from './AccordionMenu';
import UserInfo from './UserInfo';

const LeftNavigation = () => {
  return (
    <div className="w-64 bg-admin-sidebar text-white h-screen flex flex-col">
      {/* Logo and System Name */}
      <div className="p-6 border-b border-admin-sidebarHover">
        <h1 className="text-xl font-bold">管理コンソール</h1>
        <p className="text-sm text-gray-400 mt-1">Hakusensha Enet</p>
      </div>

      {/* Navigation Menu */}
      <div className="flex-1 overflow-y-auto py-4">
        <AccordionMenu />
      </div>

      {/* User Info */}
      <div className="border-t border-admin-sidebarHover">
        <UserInfo />
      </div>
    </div>
  );
};

export default LeftNavigation;
